import React, { Fragment, ReactElement } from 'react';
import {
  Avatar,
  Box,
  Grid,
  Button,
  Paper,
  Typography,
  Card,
  CardActions,
  CardContent,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import TranslatedText from '../../../../components/atoms/translated_text';
import useStyles from './styles';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';
import useQuery from 'custom_hooks/useQuery';
import { Translations } from '../../configuration';
import clsx from 'clsx';
import { Line } from 'react-chartjs-2';

import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import _ from 'lodash';
import VerifiedUserIcon from '@material-ui/icons/PersonAdd';
import NotVerifiedUserIcon from '@material-ui/icons/PersonAddDisabled';
import ErrorIcon from '@material-ui/icons/Error';
import ActiveRegistrationsIcon from '@material-ui/icons/HowToReg';
import ExcludedRegistrationsIcon from '@material-ui/icons/PausePresentation';
import NewRegistrationsIcon from '@material-ui/icons/FiberNew';
import UpdateRequestsIcon from '@material-ui/icons/Update';
import ActiveVatReturnsIcon from '@material-ui/icons/PlaylistAddCheck';
import SubmittedVatReturnsIcon from '@material-ui/icons/Publish';
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';
interface IDataItemsAnalytics {
  amtTotal: number;
  monthYear: string;
}
interface IProps {
  name: string;
  description: string;
  color: string;
  value: number;
  barPercentage: number;
  iconName: string;
  showBar: boolean;
  chart?: Array<IDataItemsAnalytics>;
}

export default function KPI(props: IProps) {
  const classes = useStyles();

  const amounts = _.map(
    props.chart ? props.chart[0] : [],
    _.property('amtTotal')
  );
  const yearMonths = _.map(
    props.chart ? props.chart[0] : [],
    _.property('monthYear')
  );

  const options = {
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: false,
    },
  };

  return (
    <>
      <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={0}>
            <Grid item xs={props.chart ? 11 : 10}>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                {props.name}
              </Typography>
              <Typography variant="h4" component="h2">
                {props.chart ? '€' : ''}
                {props.value}
              </Typography>
            </Grid>
            <Grid item xs={props.chart ? 1 : 2}>
              {/* <Avatar
                aria-label="recipe"
                className={(classes.avatar, classes.large)}
              > */}
              {getIcon(props.iconName, classes)}
              {/* </Avatar> */}
            </Grid>
          </Grid>

          {/* <Typography className={classes.pos} color="textSecondary">
            adjective
          </Typography> */}
          <Box height={props.chart ? '10px' : '40px'} alignContent={'center'}>
            <Typography variant="caption" component="p">
              {props.description}
            </Typography>
          </Box>

          {props.showBar && (
            <LinearProgressWithLabel
              value={props.barPercentage}
              color={props.color}
              classes={classes}
            />
          )}

          {props.chart && (
            <Line
              data={{
                labels: yearMonths,
                datasets: [
                  {
                    data: amounts,
                    backgroundColor:
                      props.color == 'orange'
                        ? 'yellow'
                        : 'light' + props.color,
                    borderColor: props.color,
                  },
                ],
              }}
              options={options}
              height={50}
            />
          )}
        </CardContent>

        {/* <CardActions>
          <Button size="small">Learn More</Button>
        </CardActions> */}
      </Card>
    </>
  );
}

function getIcon(iconName: string, classes: any) {
  switch (iconName) {
    case 'verifiedUsers':
      return (
        <VerifiedUserIcon fontSize="large" className={classes.greenIcon} />
      );
    case 'notVerifiedUsers':
      return (
        <NotVerifiedUserIcon fontSize="large" className={classes.orangeIcon} />
      );
    case 'incomingMessageErrors':
      return <ErrorIcon fontSize="large" className={classes.redIcon} />;
    case 'technicalErrorMessages':
      return <ErrorIcon fontSize="large" className={classes.redIcon} />;
    case 'activeRegistrations':
      return (
        <ActiveRegistrationsIcon
          fontSize="large"
          className={classes.greenIcon}
        />
      );
    case 'excludedRegistrations':
      return (
        <ExcludedRegistrationsIcon
          fontSize="large"
          className={classes.orangeIcon}
        />
      );
    case 'newRegistrations':
      return (
        <NewRegistrationsIcon fontSize="large" className={classes.blueIcon} />
      );
    case 'updateRequests':
      return (
        <UpdateRequestsIcon fontSize="large" className={classes.purpleIcon} />
      );
    case 'activeVatReturns':
      return (
        <ActiveVatReturnsIcon fontSize="large" className={classes.greenIcon} />
      );
    case 'newVatReturns':
      return (
        <NewRegistrationsIcon fontSize="large" className={classes.blueIcon} />
      );
    case 'submittedVatReturns':
      return (
        <SubmittedVatReturnsIcon
          fontSize="large"
          className={classes.blueIcon}
        />
      );
    case 'vatReturnsWithErrors':
      return <ErrorIcon fontSize="large" className={classes.redIcon} />;
    case 'vatAmountDeclared':
      return <EuroSymbolIcon fontSize="large" className={classes.blueIcon} />;
    case 'payableAmount':
      return <EuroSymbolIcon fontSize="large" className={classes.blueIcon} />;
    case 'amountPaid':
      return <EuroSymbolIcon fontSize="large" className={classes.greenIcon} />;
    case 'amountAllocated':
      return <EuroSymbolIcon fontSize="large" className={classes.orangeIcon} />;
    default:
      return <VerifiedUserIcon fontSize="large" className={classes.blueIcon} />;
  }
}

function getBarColors(
  color: string,
  classes: any
): { colorPrimary: any; barColorPrimary: any } {
  switch (color) {
    case 'green':
      return {
        colorPrimary: classes.greenColor,
        barColorPrimary: classes.greenBarColor,
      };
    case 'red':
      return {
        colorPrimary: classes.redColor,
        barColorPrimary: classes.redBarColor,
      };
    case 'orange':
      return {
        colorPrimary: classes.orangeColor,
        barColorPrimary: classes.orangeBarColor,
      };
    case 'blue':
      return {
        colorPrimary: classes.blueColor,
        barColorPrimary: classes.blueBarColor,
      };
    case 'purple':
      return {
        colorPrimary: classes.purpleColor,
        barColorPrimary: classes.purpleBarColor,
      };
    default:
      return {
        colorPrimary: '',
        barColorPrimary: '',
      };
  }
}

function LinearProgressWithLabel(props: {
  value: number;
  color: string;
  classes: any;
}) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress
          variant="determinate"
          value={props.value}
          classes={getBarColors(props.color, props.classes)}
        />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
